export const MOBILE_TYPE_NOTIFICATION = {
  sms: 'SMS',
  whatsapp: 'WhatsApp'
}
